import { Link } from "react-router-dom";
import { BRAND, WORDMARK_SUB, FOOTER_TAGLINE, NAV_LINKS } from "@/content/site";
import { LoopStrip } from "./LoopRail";
import logoUrl from "@/assets/logo-djinious-workflow.png";

export function Footer() {
  return (
    <footer className="border-t border-line/10 bg-ink-deep">
      <div className="mx-auto max-w-sheet px-6 py-16">
        <div className="flex flex-col gap-10 lg:flex-row lg:items-start lg:justify-between">
          <div className="max-w-md">
            <span className="flex items-center gap-3">
              <img src={logoUrl} alt="" loading="lazy" decoding="async" className="h-7 w-7" width={28} height={28} />
              <span className="flex flex-col leading-none">
                <span className="font-wordmark text-base tracking-tight text-bone">{BRAND}</span>
                <span className="mt-1 font-mono text-[0.625rem] uppercase tracking-[0.22em] text-bone-faint">
                  {WORDMARK_SUB}
                </span>
              </span>
            </span>
            <p className="mt-5 text-sm leading-relaxed text-bone-dim">{FOOTER_TAGLINE}</p>
          </div>

          <nav aria-label="Footer" className="flex flex-col gap-2.5">
            {NAV_LINKS.map((l) => (
              <Link key={l.to} to={l.to} className="text-sm text-bone-dim transition-colors hover:text-bone">
                {l.label}
              </Link>
            ))}
            <Link to="/book-demo" className="text-sm text-bone-dim transition-colors hover:text-bone">
              Book a demo
            </Link>
          </nav>
        </div>

        <div className="mt-14 flex flex-col gap-5 border-t border-line/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <LoopStrip />
          <p className="font-mono text-[0.6875rem] uppercase tracking-[0.12em] text-bone-faint">
            Every screenshot on this site is a capture of the running platform.
          </p>
        </div>
      </div>
    </footer>
  );
}
